module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Title Page"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iii",
      "title": "iii"
    }
  }, [_c('b', [_vm._v("HUMANE MUSIC"), _c('br'), _vm._v("EDUCATION FOR"), _c('br'), _vm._v("THE COMMON"), _c('br'), _vm._v("GOOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Edited by Iris M. Yob and"), _c('br'), _vm._v("Estelle R. Jorgensen")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_vm._v("INDIANA UNIVERSITY PRESS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-656f04f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_Yob_and_Jorgensen_fm_prod0b.vue
// module id = 66
// module chunks = 0